import Result from "slotworks/model/gameplay/records/results/result";

export default class FreespinsWheelResult extends Result {
    public freespinsWheelResult: boolean = true;
    public buyout: boolean = false;
}